import React from 'react';
import { AvailabilityChangeConfirmProps } from 'types';
import { Link } from 'components/Link/Link';
import Button from 'components/Button/Button';

import IconQuestion from 'icons/ic_ErrorQuestion.svg';
import { AmplitudeEventCategories, AmplitudeEventProperties, logAmplitudeEvent } from 'utils/Amplitude';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const AvailabilityChangeConfirm: React.FC<AvailabilityChangeConfirmProps & ComponentProps> = ({
  apps,
  menuItem,
  isAvailable,
  callback,
  styles,
  closeModal
}) => {
  const availabilityName = `${isAvailable ? '' : 'un'}available`;

  const pathnameFirstTwoSegments = window.location.pathname.split('/').slice(0, 3).join('/');

  const logInAmplitude = (action: 'confirm' | 'cancel'): void => {
    logAmplitudeEvent({
      name:
        menuItem.__typename === 'Product'
          ? `items confirmation dialog (${action})`
          : `options confirmation dialog (${action})`,
      category:
        menuItem.__typename === 'Product' ? AmplitudeEventCategories.MM_ALL_ITEMS : AmplitudeEventCategories.MM_OPTIONS,
      properties: {
        [AmplitudeEventProperties.APPS]: apps.map(({ name }) => name) || []
      }
    });
  };

  return (
    <div
      data-testid="availability-change-confirm"
      role="dialog"
      aria-labelledby="availability-change-title"
      aria-describedby="availability-change-description"
    >
      <img src={IconQuestion} alt="" />
      <h2 id="availability-change-title">Make this item {availabilityName}?</h2>
      <p id="availability-change-description" data-testid="availability-change-confirm-copy">
        This POS ID (
        <Link onClick={closeModal} href={`${pathnameFirstTwoSegments}?searchTerm=${menuItem.posId}`}>
          {menuItem.posId}
        </Link>
        ) is used in more than one place.
        <br />
        <br />
        Proceeding will make this {availabilityName} in your{' '}
        {apps.map((app, index: number): string => {
          let response = '';

          const isLast = index === apps.length - 1;

          if (index && !isLast) {
            response += ', ';
          } else if (index && isLast) {
            response += ' & ';
          }

          response += app.name;

          return response;
        })}{' '}
        menu.
      </p>
      <div className={styles.ButtonRow}>
        <Button
          onClick={() => {
            logInAmplitude('cancel');
            closeModal();
          }}
          level="low"
        >
          <span>Cancel</span>
        </Button>
        <Button
          onClick={() => {
            logInAmplitude('confirm');
            callback();
            closeModal();
          }}
        >
          <span>Yes, make {availabilityName}</span>
        </Button>
      </div>
    </div>
  );
};

export default AvailabilityChangeConfirm;
